var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex flex-row flex-align-center item-container"},[_c('div',{staticClass:"mr-2"},[_c('SpaceIconCard',[_c('SIcon',{attrs:{"name":_vm.projectIconIndicatorName,"width":"10"}})],1)],1),_c('div',{staticClass:"item-name"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }